export default __webpack_public_path__ + "static/media/Experience Selector.c46d9f75.svg";